__turbopack_context__.v({
  "button": "Button-module__EdMKcW__button",
  "contained": "Button-module__EdMKcW__contained",
  "default": "Button-module__EdMKcW__default",
  "disabled": "Button-module__EdMKcW__disabled",
  "error": "Button-module__EdMKcW__error",
  "fullWidth": "Button-module__EdMKcW__fullWidth",
  "label": "Button-module__EdMKcW__label",
  "large": "Button-module__EdMKcW__large",
  "medium": "Button-module__EdMKcW__medium",
  "outlined": "Button-module__EdMKcW__outlined",
  "primary": "Button-module__EdMKcW__primary",
  "secondary": "Button-module__EdMKcW__secondary",
  "small": "Button-module__EdMKcW__small",
  "square": "Button-module__EdMKcW__square",
  "text": "Button-module__EdMKcW__text",
  "white": "Button-module__EdMKcW__white",
  "xlarge": "Button-module__EdMKcW__xlarge",
  "xsmall": "Button-module__EdMKcW__xsmall",
});
